import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { SearchService } from '@services/search.service';
import { GlobalService } from '@common/global';
import * as _ from 'lodash';
@Component({
  selector: 'app-panswer',
  templateUrl: './panswer.component.html',
  styleUrls: ['./panswer.component.sass']
})
export class PanswerComponent implements OnInit {
  @Input() topicid: string;

/* 
  @Input('c') component: string;
  @Input('a') application: string;
  @Input('rows') rows: number;
  @Input('mediaId') mediaId: string;
  @Input('mediaType') mediaType: string;
  @Input('mediaName') mediaName: string;
  @Input('loginurl') loginurl: string; */
  discussionList: any = [];
  constructor(private _searchService: SearchService, private _global: GlobalService) { }

  ngOnChanges() {
    if (this.topicid) {
      this.list();
    }
  }
  ngOnInit() {
  }
  list() {

    let p = {
      'component': this._global.COMPONENTS_SMN,
      'application': 'discussion',
      'sortOrder': 'desc',
      'sortString': 'createdTime',
      topicId:this.topicid,
      "start": 0,
      "rows": 100
    };
    this._searchService.application(p).subscribe(
      discussionList => {
        if (!_.isEmpty(this._global.getVal(discussionList, 'response.docs', ''))) {
        this.discussionList = this._global.getVal(discussionList, 'response.docs', '');
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });

  }
}
